import PropTypes from 'prop-types'
import { Box, Icon, Text } from '@redriverpress/system'

export default function IconLabel({ icon, copy, ...props }) {
  return (
    <Box display='flex' alignItems='baseline' {...props}>
      <Icon icon={icon} pr={2} />
      <Text>{copy}</Text>
    </Box>
  )
}

IconLabel.defaultProps = {
  copy: null,
}

IconLabel.propTypes = {
  icon: PropTypes.string.isRequired,
  copy: PropTypes.string,
}
